/**
 * Apresentação dos marketplaces na vitrine: rótulo, cor de detalhe e marca.
 *
 * Isto é SÓ apresentação. Nenhuma regra de filtro, classificação ou compra usa
 * este arquivo: a busca filtra pelo slug canônico, que o backend classifica com
 * `_click_marketplace`. As chaves abaixo são exatamente esses slugs, e um teste
 * compara com `_CLICK_MARKETPLACE_HOSTS` no server.py para não divergirem.
 *
 * `cor` é o microdetalhe usado no rodapé e na Central (um ponto ao lado do nome).
 * `marca` é a identidade real da loja, usada só nos tiles de "Explorar por loja":
 *   logo      wordmark oficial (src/assets/lojas, origem em ORIGEM.md)
 *   fundo     cor principal da marca, fundo sólido do tile
 *   apoio     cor secundária da marca (sombra colorida no hover e no claro)
 *   apoioRgb  a mesma cor de apoio em "r, g, b", para usar com transparência
 *   alturaLogo altura do logo no desktop, em px; cada wordmark tem proporção
 *             diferente e é ajustado para o mesmo peso visual
 * O tile é igual no escuro e no claro: a cor é da marca, não do tema. O que
 * muda por tema é só a borda e a sombra (index.css, .sv-loja-tile).
 *
 * Só entram lojas com ofertas compráveis hoje (medido em 2026-09-12: Mercado
 * Livre 3965, Shopee 2436, Amazon 157, Magalu 1). Aliexpress, Netshoes e
 * Zattini existem no classificador, mas estão com zero ofertas.
 */
import logoMercadoLivre from '../assets/lojas/mercadolivre.svg';
import logoShopee from '../assets/lojas/shopee-branco.svg';
import logoAmazon from '../assets/lojas/amazon-branco.svg';
import logoMagalu from '../assets/lojas/magalu-branco.svg';

export const MARKETPLACES = [
    {
        slug: 'mercadolivre', label: 'Mercado Livre', cor: '#FFE600',
        marca: { logo: logoMercadoLivre, fundo: '#FFE600', apoio: '#2D3277', apoioRgb: '45, 50, 119', alturaLogo: 44 },
    },
    {
        slug: 'shopee', label: 'Shopee', cor: '#FF5A2B',
        marca: { logo: logoShopee, fundo: '#EE4D2D', apoio: '#EE4D2D', apoioRgb: '238, 77, 45', alturaLogo: 36 },
    },
    {
        slug: 'amazon', label: 'Amazon', cor: '#FF9A1F',
        marca: { logo: logoAmazon, fundo: '#262626', apoio: '#FF9900', apoioRgb: '255, 153, 0', alturaLogo: 34 },
    },
    {
        slug: 'magalu', label: 'Magalu', cor: '#2F8BFF',
        marca: { logo: logoMagalu, fundo: '#0086FF', apoio: '#0086FF', apoioRgb: '0, 134, 255', alturaLogo: 34 },
    },
];

export const buscaPorMarketplace = (slug) => `/busca?marketplace=${encodeURIComponent(slug)}`;
